require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-toorak-garden-residence-featured-in-habitusliving.json") })
        }
      }, "path---journal-toorak-garden-residence-featured-in-habitusliving");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-toorak-garden-residence-featured-in-habitusliving!./.cache/json/journal-toorak-garden-residence-featured-in-habitusliving.json
// module id = 545
// module chunks = 231608221292675